import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  LeadModel,
  MessageBaseModel,
  MessageSource,
  MESSAGE_SOURCES_METADATA,
  ReviewModel,
} from '@boxx/messages-core';
import { GBMConversationItemModel } from '../../models/GBMessage.model';

@Component({
  selector: 'boxx-conversation-item',
  templateUrl: './conversation-item.component.html',
  styleUrls: ['./conversation-item.component.scss'],
})
export class ConversationItemComponent implements OnInit {
  @Input() detail = true;
  @Input() canShowTrashIcon = false;
  @Input() message: GBMConversationItemModel & LeadModel & ReviewModel;
  @Output() whenDelete = new EventEmitter<MessageBaseModel>();
  @Output() whenOpen = new EventEmitter<MessageBaseModel>();

  // eslint-disable-next-line @typescript-eslint/naming-convention
  MESSAGE_SOURCE = MessageSource;
  sources = MESSAGE_SOURCES_METADATA;

  constructor() {}

  ngOnInit(): void {}

  deleteMessage() {
    this.whenDelete.emit(this.message);
  }

  openMessage(message: MessageBaseModel) {
    this.whenOpen.emit(message);
  }

  splitLongMessage(message){
    if(message && message.length > 0){
      if(message.length >= 28){
        return message.substring(0, 30).concat('...');
      }
      else{
        return message;
      }
    }
    return message;
  }
}
